export default __webpack_public_path__ + "static/media/caret-left.18e98792.svg";